<template>
  <ConfirmModal
    v-if="showCloseConfirmationModal"
    wrapper-class="max-w-4xl"
    :title="t('Reviews.edit.confirmModal.title')"
    :description="t('Reviews.edit.confirmModal.description')"
    @close-dialog="showCloseConfirmationModal = false"
  >
    <template #actions>
      <div class="mt-6 flex justify-end px-6 pb-6">
        <RouterLink class="btn-outline-color-s" :to="backTo" data-testid="reviews-close-confirm">
          {{ t('Reviews.edit.confirmModal.confirm') }}
        </RouterLink>
        <button class="btn-primary-color-s ml-4" data-testid="accept-button" @click="showCloseConfirmationModal = false">
          {{ t('Reviews.edit.confirmModal.abort') }}
        </button>
      </div>
    </template>
  </ConfirmModal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { type RouteLocationRaw } from 'vue-router'

import { ConfirmModal } from '@/components'

defineProps<{
  backTo: RouteLocationRaw
}>()

const { t } = useI18n()

const showCloseConfirmationModal = ref(false)

function show() {
  showCloseConfirmationModal.value = true
}

defineExpose({
  show,
})
</script>
